<template>
  <div>
    <div class="custom_1" v-if="showStart">
      <div class="flex2 custom_1_mar5" v-for="item in newsObj.describeText" :key="item.key">
        <div class="flex00auto">
          [
          <div style class="custom_title">{{item.key}}</div>]
        </div>
        <div class="mar_left">{{item.value||"无"}}</div>
      </div>
      <div class="flex2" v-for="item in newsObj.disease" :key="item.key">
        <div style class="custom_title">{{item.key}}：</div>
        <div class="mar_left">{{item.value||"无"}}</div>
      </div>
    <div class="drugList">
      <div class="flex00auto custom_title">[药品信息]</div>
      <div v-for="item in newsObj.drugInfomation.detail" :key="item.ComName">
        {{item.ComName+item.Specs}}
        <span style="margin-left:5px">{{item.Count+item.Unit}}</span>
      </div>
    </div>

    <div class="custom_1_mar5">
      <div class="flex00auto flex2">
        [
        <div style class="custom_title">{{imgUrlsObj.name}}</div>]
      </div>
      <div class="flex2 imgList" v-if="imgUrlsObj.imgUrls!=null&&imgUrlsObj.imgUrls.length>0">
        <viewer :images="imgUrlsObj.imgUrls">
          <img
            style="width:60px;height:60px;cursor:pointer;;margin-right:5px;border-radius"
            :src="item"
            v-for="(item,index) in imgUrlsObj.imgUrls"
            :key="index"
            @load="onImageLoaded"
            class="vuewer_img"
          />
        </viewer>
      </div>
    </div>

    <div v-if="imgUrlsObj.imgUrls==null||imgUrlsObj.imgUrls.length==0">无</div>
    <!-- <div class="custom_1_change_btn" @click="gotoChange" v-if="$store.state.inquiryStatus!=3&&$store.state.inquiryStatus!=5&&$store.state.inquiryStatus!=1">点击修改</div> -->
  
    </div>

  </div>
</template>
<script>
export default {
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      newsObj: {},
      imgUrlsObj: {},
      showStart: false
    };
  },
  methods: {
    gotoChange() {
      this.$bus.$emit("change");
      return;
    },
    onImageLoaded(event) {
      this.$bus.$emit("image-loaded", event);
    }
  },
  mounted() {
    //
    console.log(this.payload);
    this.newsObj = JSON.parse(this.payload.data).data || {};
    this.imgUrlsObj = this.newsObj.images;
    console.log(this.newsObj);
    console.log(this.imgUrlsObj);
    this.showStart = true;
  }
};
</script>
<style lang="scss" scoped>
.custom_1 {
  font-weight: 500;
  .custom_title {
    min-width: 60px;
    text-align-last: justify;
    display: inline-block;
    flex: 0 0 auto;
  }
  .imgList {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .custom_1_change_btn {
    color: #fea57a;
    text-align: center;
    border-top: 1px solid #e2e2e2;
    margin-top: 10px;
    padding-top: 5px;
    cursor: pointer;

    margin-top: 5px;
    cursor: pointer;
  }
  .custom_1_mar5 {
    margin-bottom: 5px;
  }
  .mar_left {
    margin-left: 5px;
  }
  .flex00auto {
    flex: 0 0 auto;
  }
}
</style>